import { useDataSubmit } from 'Simple/Data'

export function useOnClick(props) {
  let submit = useDataSubmit({
    viewPath: props.viewPath,
    context: 'edit_phone',
  })
  return async function onClick() {
    submit({ type: 'new_phone_for_patient' })
  }
}
